// Not Found (404) Web Component

class NotFound extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="not-found-container">
        <div class="not-found-content">
          <div class="not-found-icon">🔍</div>
          <h1>404 - Page Not Found</h1>
          <p class="not-found-message">
            Oops! Looks like this page took a wrong turn somewhere. 
            It might have wandered off to join the circus! 🎪
          </p>
          <div class="not-found-actions">
            <a href="/" class="btn btn-primary">🏠 Go Home</a>
          </div>
        </div>
      </div>
    `;
  }
}

// Register the custom element
customElements.define('not-found', NotFound);

export default NotFound;

